//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faCheckCircle,
  faTimesCircle,
  faAd,
  faBrowser,
  faPresentation,
  faGamepadAlt,
  faFilm,
} from '@fortawesome/pro-light-svg-icons';
import {
  faNewspaper,
  faRectanglePro,
} from '@fortawesome/pro-regular-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';

export default {
  name: 'LicensingPage',
  components: {
    // BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    AboutTabs: () => import('@/components/about/AboutTabs.vue'),
    ColumnSection: () => import('@/components/core/elements/ColumnSection.vue'),
    CardSection: () => import('@/components/core/elements/CardSection.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
  },
  data() {
    return {
      faCheckCircle,
      faTimesCircle,
      faNewspaper,
      faRectanglePro,
      exampleElements: [
        {
          icon: faAd,
          iconBg: 'bg-primary',
          title: this.$t('licensing.advertisements'),
          text: this.$t(this.$wbr('licensing.advertisements_text')),
        },
        {
          icon: faBrowser,
          iconBg: 'bg-success-700',
          title: this.$t('licensing.websites_blogs'),
          text: this.$t(this.$wbr('licensing.websites_blogs_text')),
        },
        {
          icon: faPresentation,
          iconBg: 'bg-warning-600',
          title: this.$t('licensing.events'),
          text: this.$t(this.$wbr('licensing.events_text')),
        },
        {
          icon: faGamepadAlt,
          iconBg: 'bg-pink',
          title: this.$t('licensing.software_apps_games'),
          text: this.$t(this.$wbr('licensing.software_apps_games_text')),
        },
        {
          icon: faFilm,
          iconBg: 'bg-blue',
          title: this.$t(this.$wbr('term.tv_&_films')),
          text: this.$t(this.$wbr('licensing.tv_and_films_text')),
        },
        {
          icon: faYoutube,
          iconBg: 'bg-danger',
          title: 'YouTube',
          text: this.$t(this.$wbr('licensing.youtube_text')),
        },
      ],
    };
  },
  computed: {
    pageTitle() {
      return this.$t('nav.licensing');
    },
    pageDescription() {
      return this.$t('licensing.page_description_{count}', { count: renderContentCount(this, publishedContentCounts.total.element) });
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('nav.licensing'),
          link: this.$link('/licensing').fullPath(),
          active: true,
        },
      ];
    },
  },
};
